<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import BaseCard from '@/components/ui/BaseCard.vue';

const route = useRoute();
const slice = computed(() => (route.meta.slice as string) ?? 'a future slice plan');
const title = computed(() => (route.meta.title as string) ?? String(route.name ?? route.path));
</script>

<template>
  <BaseCard padding="lg">
    <h1 class="text-page text-fg mb-2">{{ title }}</h1>
    <p class="text-body text-muted">
      Coming in <span class="font-mono tabular-nums">{{ slice }}</span>.
    </p>
    <p class="text-caption text-muted-2 mt-4">
      This is a known build-in-progress placeholder — this route ships in the
      slice plan listed above. It is not an error.
    </p>
  </BaseCard>
</template>
